import type { ReactElement } from 'react'
import React from 'react'

import { inlineNotification } from '@ui-kit/components/InlineNotification/styles'

import { VARIANT_STYLE_MAP } from './constants.web'
import type { Props } from './types'
import * as utils from './utils'

const InlineNotification = (props: Props): ReactElement => {
  const variant = props.variant ?? 'error'
  const InlineNotificationIcon = utils.getNotificationIcon(VARIANT_STYLE_MAP, variant)
  const { container, text } = inlineNotification({
    type: variant,
  })

  return (
    <div className={container()} data-testid={props.id} id={props.id}>
      <InlineNotificationIcon />
      <p className={text()}>{props.message}</p>
    </div>
  )
}

export default InlineNotification
